import { Table, TableHeaderCell, SortTH } from 'foundations-components/transitional/components/Table';
import { Text } from 'foundations-components/components/Text';
import { useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalEditPanelTableCheckboxRow } from './ApprovalEditPanelTableCheckboxRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ApprovalEditPanelTable = ({
  approvedApproverUserIds,
  approversAll,
  changeCheckbox,
  selectedApproverIdsMutable,
  superAdminUserIds,
  validApproverOwnerIds
}) => {
  const {
    data
  } = useApprovalContext();
  const [sortDirection, setSortDirection] = useState('ascending');
  const approversAllSortable = useMemo(() => {
    if (sortDirection === 'ascending') {
      return [...approversAll].sort((a, b) => a.firstName.toLocaleLowerCase() < b.firstName.toLocaleLowerCase() ? -1 : 1);
    } else {
      return [...approversAll].sort((a, b) => b.firstName.toLocaleLowerCase() < a.firstName.toLocaleLowerCase() ? -1 : 1);
    }
  }, [approversAll, sortDirection]);
  const sortTable = event => {
    var _event$target$value;
    setSortDirection((_event$target$value = event.target.value) !== null && _event$target$value !== void 0 ? _event$target$value : 'ascending');
  };
  if (!data) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Table, {
    bordered: true,
    children: [/*#__PURE__*/_jsxs("colgroup", {
      children: [/*#__PURE__*/_jsx("col", {}), /*#__PURE__*/_jsx("col", {
        width: 150
      })]
    }), /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx(SortTH, {
          onSortChange: sortTable,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.users"
          })
        }), /*#__PURE__*/_jsx(TableHeaderCell, {
          textAlign: "right",
          children: /*#__PURE__*/_jsx(Text, {
            typography: "detail-100",
            textTransform: "none",
            textAlign: "right",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.selected",
              options: {
                count: selectedApproverIdsMutable.length
              }
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: approversAllSortable.map(approver => /*#__PURE__*/_jsx(ApprovalEditPanelTableCheckboxRow, {
        approver: approver,
        changeCheckbox: changeCheckbox,
        checkboxIsApproved: approvedApproverUserIds.includes(approver.activeUserId),
        checkboxIsDisabled: approvedApproverUserIds.includes(approver.activeUserId) || approver.activeUserId === data.requester.activeUserId,
        checkboxIsRequester: approver.activeUserId === data.requester.activeUserId,
        checkboxIsSelected: selectedApproverIdsMutable.includes(approver.ownerId),
        isSuperAdmin: superAdminUserIds.has(approver.activeUserId),
        showInvalidApproverWarning: !approvedApproverUserIds.includes(approver.activeUserId) && !validApproverOwnerIds.has(approver.ownerId)
      }, approver.ownerId))
    })]
  });
};